import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { getClientUserList, putClientUserDetails,putClientManagementDetails } from "../Actions/ClientManagementAPI";

let user = JSON.parse(localStorage.getItem("currentUser"));

class ClientManagementDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: ""
        }
    }

componentDidMount() {
        const { match, dispatch } = this.props;
        const { params } = match;
        const { id } = params;
        dispatch(getClientUserList(id));
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        // const { match, dispatch } = nextProps;
        // const { params } = match;
        // const { id } = params;
        // let updatedState = {};
        // if (id !== prevState.id) {
        //     prevState.id = id;
        //     updatedState.id = id;
        //     //   dispatch(getClientManagementDetails(id));
        // }
        // return updatedState;
    }
    ShowSidePanel = () => {
        this.setState({ showSidePane: false })
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/Management/Client");
    }
    render() {
        const { ClientDetails, clientUserList } = this.props;
        let fleetManager = clientUserList && clientUserList.filter(r => r.role === "fleetmanager");
        let techSuperintendent = clientUserList && clientUserList.filter(r => r.role === "superintendent");
        let techExecutive = clientUserList && clientUserList.filter(r => r.role === "technicalexecutive");
        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row resource-list-auth-date">
                                <div className="panel-box search-filter-box">
                                    <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" onClick={() => this.ShowSidePanel()}>&larr; Return</button>
                                    <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                        <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                            <h5 className="card-title m-2" style={{ color: "092a51" }}>Client Details</h5>
                                        </div>
                                        <div className="pt-3 pb-3 search-filter-box">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <label className="form-label" >Company Name :</label>
                                                    <span>{" "}{ClientDetails ? ClientDetails.companyName : ""}</span>
                                                </div>
                                                <div className="col-sm-6">
                                                    <label className="form-label" >Email :</label>
                                                    <span>{" "}{ClientDetails ? ClientDetails.email : ""}</span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label className="form-label" >Phone :</label>
                                                    <span>{" "}{ClientDetails ? ClientDetails.phone : ""}</span>
                                                </div>
                                                <div className="col-sm-6">
                                                    <label className="form-label" >Address :</label>
                                                    <span>{" "}{ClientDetails ? ClientDetails.address : ""}</span>
                                                </div>
                                                <div className="col-sm-6">
                                                    <label className="form-label" >TE Forms Applicable :</label>
                                                    <span>{" "}{ClientDetails ? ClientDetails.isTeFromApplicable === true ? "Yes" : "No" : ""}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                            <h5 className="card-title m-2" style={{ color: "092a51" }}>Fleet Manager</h5>
                                        </div>
                                        <div className="pt-3 search-filter-box">
                                            {fleetManager && fleetManager.length ? fleetManager.map(item => (
                                                <div className="card MM-card-content click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
                                                    <div className="p-3">
                                                        <div className="resource-list-auth-date">
                                                            <div className="row">
                                                                <div className="col-sm-12">
                                                                    <div className="row mt-1">
                                                                        <div className="col-sm-4">
                                                                            <span><strong>Name : </strong><span className="italicFont ">{item.name}</span></span>
                                                                        </div>
                                                                        <div className="col-sm-4">
                                                                            <span><strong>Email : </strong><span className="italicFont ">{item.email}</span></span>
                                                                        </div>
                                                                        <div className="col-sm-4">
                                                                            <span><strong>Phone : </strong><span className="italicFont ">{item.phone}</span></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                                : null
                                            }
                                        </div>
                                        <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                            <h5 className="card-title m-2" style={{ color: "092a51" }}>Technical Superintendents</h5>
                                        </div>
                                        <div className="pt-3 search-filter-box">
                                            {techSuperintendent && techSuperintendent.length ? techSuperintendent.map(item => (
                                                <div className="card MM-card-content click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
                                                    <div className="p-3">
                                                        <div className="resource-list-auth-date">
                                                            <div className="row">
                                                                <div className="col-sm-12 m-auto">
                                                                    <div className="row">
                                                                        <div className="col-sm-4">
                                                                            <span><strong>Name : </strong><span className="italicFont ">{item.name}</span></span>
                                                                        </div>
                                                                        <div className="col-sm-4">
                                                                            <span><strong>Email : </strong><span className="italicFont ">{item.email}</span></span>
                                                                        </div>
                                                                        <div className="col-sm-4">
                                                                            <span><strong>Phone : </strong><span className="italicFont ">{item.phone}</span></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                                : null
                                            }
                                        </div>
                                        <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                            <h5 className="card-title m-2" style={{ color: "092a51" }}>Technical Executive</h5>
                                        </div>
                                        <div className="pt-3 search-filter-box">
                                            {techExecutive && techExecutive.length ? techExecutive.map(item => (
                                                <div className="card MM-card-content click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
                                                    <div className="p-3">
                                                        <div className="resource-list-auth-date">
                                                            <div className="row">
                                                                <div className="col-sm-12">
                                                                    <div className="row mt-1">
                                                                        <div className="col-sm-4">
                                                                            <span><strong>Name : </strong><span className="italicFont ">{item.name}</span></span>
                                                                        </div>
                                                                        <div className="col-sm-4">
                                                                            <span><strong>Email : </strong><span className="italicFont ">{item.email}</span></span>
                                                                        </div>
                                                                        <div className="col-sm-4">
                                                                            <span><strong>Phone : </strong><span className="italicFont ">{item.phone}</span></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 pb-2 pt-2">
                                            <div className="search-btn-col mt-1" style={{ textAlign: "right" }}>
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.EditClientDetails(ClientDetails)}>
                                                    {" "}Edit{" "}
                                                </button>
                                                <button
                                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                    type="button" onClick={() => this.DeletePopup()}> {" "}Delete{" "}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }

    DeletePopup() {
    confirmAlert({
        message: 'Are you sure want to delete ?',
        buttons: [
            {
                label: 'Yes',
                onClick: () => {
                    this.DeleteClientDetails()
                }
            },
            {
                label: 'No',
                onClick: () => { }
            }
        ]
    });
    }

    DeleteClientDetails() {
        const { clientUserList, ClientDetails, dispatch, history,match } = this.props;
        let clientuserArray = [];
            clientUserList.map((r) => {
           if(r.clientUserId){
            clientuserArray.push(r.clientUserId);   
           }
        })
        let deleteClient = {
            clientId: ClientDetails.clientId,
            companyName: ClientDetails.companyName,
            email: ClientDetails.email,
            phone: ClientDetails.phone,
            address: ClientDetails.address,
            isDeleted: true,
            modifiedBy: "",
        }
        let clientuser =[{
            clientUserIds:clientuserArray.toString(),
            clientId:parseInt(match.params.id),
            isDeleted: true,
            modifiedBy: user.email
          }]
        dispatch(putClientManagementDetails(deleteClient));
        dispatch(putClientUserDetails(clientuser));
        dispatch({ type: "ShowSidePan", data: false });
        history.push("/Home/Management/Client");
    }

    EditClientDetails(item) {
        const { clientUserList, dispatch, history } = this.props;
        let FleetManager = clientUserList && clientUserList.filter(r => r.role === "fleetmanager");
        let TechSuperintendent = clientUserList && clientUserList.filter(r => r.role === "superintendent");
        let TechExecutive = clientUserList && clientUserList.filter(r => r.role === "technicalexecutive");
        dispatch({ type: "GetFleetManagerlist", data: FleetManager });
        dispatch({ type: "GetTechSuperintendentlist", data: TechSuperintendent });
        dispatch({ type: "GetTechExecutivelist", data: TechExecutive });
        history.push(`/Home/Management/ClientEdit/${item.clientId}`);
        dispatch({ type: "ShowSidePan", data: false });
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        ClientDetails: state.MasterScreenReducer.ClientDetails,
        clientUserList: state.MasterScreenReducer.clientUserList,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientManagementDetail));